// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "main/css/" + "about" + "." + "60f9fd13" + ".css";
};